/**
 * SealedPrepCard — the "Request sealed until started" card the New Business
 * Assistant sees on an Inbox preparation request (CLAUDE.md §40), the prep
 * counterpart of FileDetail's "File sealed until drawn" card.
 * Extracted verbatim from PrepRequestDetail.jsx (step P7 of the
 * PrepRequestDetail decomposition, audit §6.2); the moved block keeps its
 * original indentation.
 */

import { Lock } from 'lucide-react';

export default function SealedPrepCard() {
  return (
          <div style={styles.sealedCard}>
            <div style={styles.sealedIconWrap}>
              <Lock size={22} color="var(--cp-primary)" />
            </div>
            <h3 style={styles.sealedTitle}>Request sealed until started</h3>
            <p style={styles.sealedBody}>
              The tasks, voice note and notes will unlock the moment you click{' '}
              <strong>Start preparation</strong>. Once started, the request is yours.
            </p>
          </div>
  );
}

const styles = {
  sealedCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '2rem 1.5rem',
    margin: '12px 0 4px',
    background: 'color-mix(in srgb, var(--cp-primary) 5%, transparent)',
    border: '1px dashed color-mix(in srgb, var(--cp-primary) 25%, transparent)',
    borderRadius: '12px',
  },
  sealedIconWrap: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'color-mix(in srgb, var(--cp-primary) 10%, transparent)',
    marginBottom: '0.75rem',
  },
  sealedTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    color: 'var(--cp-primary)',
    margin: '0 0 0.4rem',
  },
  sealedBody: {
    fontSize: '0.85rem',
    color: 'var(--cp-text-muted)',
    lineHeight: 1.5,
    margin: 0,
    maxWidth: '420px',
  },
};
